import keyMirror from 'keymirror';

export const dailyReportActionTypes = keyMirror({
	GET_DAILY_REPORT_REQUEST: null,
	GET_DAILY_REPORT_SUCCESS: null,
	GET_DAILY_REPORT_ERROR: null,
});

export const DAILY_PROGRESS_TYPES = {
	SHORT: 'short',
	SMALL: 'small',
	FULL: 'full',
} as const;

export type DailyProgressType = (typeof DAILY_PROGRESS_TYPES)[keyof typeof DAILY_PROGRESS_TYPES];
